define('shared/util/providers/data/offerDate',['shared/util/registers/DataProvider', 'shared/lib/RSVP'], 
function(DataProvider, RSVP){

    var TEXT_TEXT_CALENDAR_MONTH = 'TEXT_CALENDAR_MONTH';
    var TEXT_OFFER_END_MONTH = 'offerEndMonth';
    var TEXT_OFFER_END_DAY = 'offerEndDay';
    var NOW = new Date();
    var OFFER_END_MONTH = getOfferEndMonth();
    var OFFER_END_DAY =  getOfferEndDay();
    var done;

    function getOfferEndMonth () {
        return NOW.getMonth();
    }

    function getOfferEndDay () {
        var offerEndDay = -1;

        var currentDay = NOW.getDate();
        var fourDaysLater = new Date();
        fourDaysLater.setDate(currentDay + 4);

        if( NOW.getMonth() != fourDaysLater.getMonth() ) {
            // get last day of current month ( rather than 1st day of next month );
            offerEndDay = new Date(NOW.getYear(), NOW.getMonth() + 1, 0).getDate();
        }
        else {
            var currentDayOfWeek = NOW.getDay();
            switch ( currentDayOfWeek ) {
                case 1:
                case 5:
                    offerEndDay = currentDay + 2;
                    break;
                case 2:
                case 6:
                    offerEndDay = currentDay + 1;
                    break;
                case 0:
                case 3:
                    offerEndDay = currentDay + 0;
                    break;
                default: //Calendar.THURSDAY
                    offerEndDay = currentDay + 3;
                    break;
            }
        }

        return offerEndDay;
    }

    function registerOfferEndMonth(getMonth){
        var provider = {
            id: TEXT_OFFER_END_MONTH,
            value: function(){
                return getMonth(OFFER_END_MONTH);
            }
        };
        DataProvider.instance.register( provider );
    }

    function registerOfferEndDay(){
        var provider = {
            id: TEXT_OFFER_END_DAY,
            value: function(){
                return OFFER_END_DAY;
            }
        };
        DataProvider.instance.register( provider );
    }

    return {
        provide: function(){
            
            if ( done ) {
                return done;
            }

            done = RSVP.resolve()
                .then(function(){
                    return new RSVP.Promise(function(resolve, reject){
                        function handle(entity){
                            if ( entity.id == TEXT_TEXT_CALENDAR_MONTH ) {
                                resolve(entity);
                                DataProvider.instance.off('register', handle);
                            }
                        }
                        DataProvider.instance.on('register', handle);

                        DataProvider.instance
                            .has(TEXT_TEXT_CALENDAR_MONTH)
                            .then(function( hasText ){
                                if ( hasText === true ) {
                                    DataProvider.instance.get(TEXT_TEXT_CALENDAR_MONTH)
                                        .then(resolve);
                                }
                            });
                    });
                })
                .then(function( entity ){
                    var getMonth = entity.value();

                    return RSVP.all([
                        registerOfferEndMonth(getMonth),
                        registerOfferEndDay()
                    ]);
                });

            return done;
        }
    };
});
